import Mutations from '../../odata/mutations';

export default { ...new Mutations('sectionLineItem'), ...new Mutations('sectionLineItems') };
